import styled from 'styled-components';
import ArticleCard from '../components/ArticleCard.js';

const Div1 = styled("div")`
    
        border: 2px solid black; /* Ensure consistent borders for all grid items */

`;

const SportsGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 2fr);
    grid-template-rows: repeat(9, 30vh);

    background: #959387;

    font-family: "Oswald", sans-serif;
    font-weight: 600;
    font-size: 18vh;

    border: 2px solid black;
    line-height: 22vh;
    

    .S {
        grid-row: 1;
        grid-column: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }
    .P {
        grid-row: 1;
        grid-column: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }
    .O {
        grid-row: 1;
        grid-column: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }
    .R {
        grid-row: 2;
        grid-column: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }
    .T {
        grid-row: 2;
        grid-column: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }
    .S1 {
        grid-row: 2;
        grid-column: 4;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }


    .S3 {
        grid-row: 1;
        grid-column: 4;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }


    .S4 {
        grid-row: 2;
        grid-column: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }


    .B3 {
        grid-row: 6;
        grid-column: 1;
        border: inherit;
    }

    .B4 {
        grid-row: 6;
        grid-column: 4;
        border: inherit;
    }

    .B5 {
        grid-row: 9;
        grid-column: 1;
        border: inherit;
    }
    .B6 {
        grid-row: 9;
        grid-column: 4;
        border: inherit;
    }


    .A3 {
        grid-row: 6;
        grid-column: 2 / 4;
        border: inherit;
       
    }

    .A4 {
        grid-row: 4;
        grid-column: 1/3;
        border: inherit;
        
    }

    .A5 {
        grid-row: 4;
        grid-column: 3/5;
        border: inherit;
       
    }

    .A6 {
        grid-row: 5;
        grid-column: 1/3;
        border: inherit;
       
    }

    .A7 {
        grid-row: 5;
        grid-column: 3/5;
        border: inherit;
     
    }

    .A8 {
        grid-row: 3;
        grid-column: 1/3;
        border: inherit;
    
    }

    .A9 {
        grid-row: 3;
        grid-column: 3/5;
        border: inherit;
      
    }

    .A10 {
        grid-row: 9;
        grid-column: 2/4;
        border: inherit;
     
    }

    .A11 {
        grid-row: 8;
        grid-column: 1/3;
        border: inherit;
   
    }

    .A12 {
        grid-row: 8;
        grid-column: 3/5;
        border: inherit;
   
    }

    .A13 {
        grid-row: 7;
        grid-column: 1/3;
        border: inherit;
   
    }

    .A14 {
        grid-row: 7;
        grid-column: 3/5;
        border: inherit;
   
    }
   
`;

const MobileSports = styled("div")`
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    grid-template-rows: repeat(2, 20vh);

    background: #C7BDAC;

    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-size: 10vh;

    border: 2px solid black;
    line-height: 22vh;


    .S {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
    }
    .P {
        grid-row: 1;
        grid-column: 2;
        border: inherit;
    }

    .O {
        grid-row: 1;
        grid-column: 3;
        border: inherit;
    }

    .R {
        grid-row: 2;
        grid-column: 2;
        border: inherit;
    }

    .T {
        grid-row: 2;
        grid-column: 3;
        border: inherit;
    }

    .S1 {
        grid-row: 2;
        grid-column: 4;
        border: inherit;
    }
   
   
`

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    
    gap: 0px;
    @media screen and (max-width: 426px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

const Container = styled.div`
    margin: 0 auto;
    position: relative;
    height: auto;
    padding: 0;
    width: 100%;
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
`;

const Sports = (props) => {
    let a1 = props.sports[0];
    let a2 = props.sports[1];
    let a3 = props.sports[2];
    let a4 = props.sports[3];
    let a5 = props.sports[4];
    let a6 = props.sports[5];
    let a7 = props.sports[6];
    let a8 = props.sports[7];
    let a9 = props.sports[8];
    let a10 = props.sports[9];
    let a11 = props.sports[10];
    let a12 = props.sports[11];
    let a13 = props.sports[12];
    let a14 = props.sports[13];
    const isMobile = window.innerWidth <= 456;
    return (
        <>
         {!isMobile ? (
        <>
            <SportsGrid>
                
                <div class="S">S</div>
                <div class="P">P</div>
                <div class="O">O</div>
                <div class="R">R</div>
                <div class="T">T</div>
                <div class="S1">S</div>
                <div class="S3">
                </div>
                <div class="S4">
                </div>
                
               
                <div class="B3"></div>
                <div class="A3">
                <ArticleCard
                        position='right'
                        article_title={a7.article_title}
                        article_url={a7.article_url}
                        article_byline={a7.article_byline}
                        article_image={a7.article_image}></ArticleCard>
                </div>
                <div class="B4"></div>

                <div class="A4"><ArticleCard
                        position='left'
                        article_title={a3.article_title}
                        article_url={a3.article_url}
                        article_byline={a3.article_byline}
                        article_image={a3.article_image}></ArticleCard></div>
                <div class="A5"><ArticleCard
                        position='right'
                        article_title={a4.article_title}
                        article_url={a4.article_url}
                        article_byline={a4.article_byline}
                        article_image={a4.article_image}></ArticleCard></div>

                <div class="A6">
                <ArticleCard
                        position='right'
                        article_title={a5.article_title}
                        article_byline={a5.article_byline}
                        article_url={a5.article_url}
                        article_image={a5.article_image}></ArticleCard>
                </div>
                <div class="A7"><ArticleCard
                        position='left'
                        article_title={a6.article_title}
                        article_byline={a6.article_byline}
                        article_url={a6.article_url}
                        article_image={a6.article_image}></ArticleCard></div>

                <div class="A8"><ArticleCard
                        position='right'
                        article_title={a1.article_title}
                        article_byline={a1.article_byline}
                        article_url={a1.article_url}
                        article_image={a1.article_image}></ArticleCard></div>
                <div class="A9">
                <ArticleCard
                        position='left'
                        article_title={a2.article_title}
                        article_byline={a2.article_byline}
                        article_url={a2.article_url}
                        article_image={a2.article_image}></ArticleCard>
                </div>
                

                <div class="B5"></div>
                <div class="A10">
                <ArticleCard
                        position='left'
                        article_title={a12.article_title}
                        article_url={a12.article_url}
                        article_byline={a12.article_byline}
                        article_image={a12.article_image}></ArticleCard>
                </div>
                <div class="B6"></div>

                <div class="A11">
                <ArticleCard
                        position='left'
                        article_title={a10.article_title}
                        article_byline={a10.article_byline}
                        article_url={a10.article_url}
                        article_image={a10.article_image}></ArticleCard>
                </div>
                <div class="A12">
                <ArticleCard
                        position='right'
                        article_title={a11.article_title}
                        article_byline={a11.article_byline}
                        article_url={a11.article_url}
                        article_image={a11.article_image}></ArticleCard>
                </div>

                <div class="A13">
                <ArticleCard
                        position='right'
                        article_title={a8.article_title}
                        article_byline={a8.article_byline}
                        article_url={a8.article_url}
                        article_image={a8.article_image}></ArticleCard>
                </div>
                <div class="A14"><ArticleCard
                        position='left'
                        article_title={a9.article_title}
                        article_byline={a9.article_byline}
                        article_url={a9.article_url}
                        article_image={a9.article_image}></ArticleCard></div>

            </SportsGrid>

        </>
        ) : (
            <>
                <MobileSports>
                    <div class="S">S</div>
                    <div class="P">P</div>
                    <div class="O">O</div>
                    <div class="R">R</div>
                    <div class="T">T</div>
                    <div class="S1">S</div>
                </MobileSports>
                <Container>
                    <Grid>
                        {props && props.sports ? props.sports.map((item, index) => {
                            return (
                                <ArticleCard
                                        key={index}
                                        position={index % 2 === 0 ? "left" : "right"}
                                        color={"#959387"}
                                        article_title={item.article_title}
                                        article_byline={item.article_byline}
                                        article_image={item.article_image}></ArticleCard>
                            );
                        }) : null}
                    </Grid>
                </Container>
            </>
        )}
        </>
        
    )
}

export default Sports;